import * as React from "react";
import Card from "../components/Card";

export interface FoodProps {}

const Food: React.FC<FoodProps> = props => {
  return (
    <div>
      <Card title="Food" titleBackgroundColor="#FCBA6A"></Card>
      <Card title="Hamburgers">
        <h2>Blue Cheese Burger</h2>
        <p>Blue cheese, rocket, tomatoes, onions, meat, bread</p>

        <h2>Vegetarian Burger</h2>
        <p>Cheese, rocket, tomatoes, onions, vegetarian meat, bread</p>

        <h2>Blue Cheese Burger</h2>
        <p>Cheese, rocket, tomatoes, onions, meat, bread</p>
      </Card>

      <Card title="Pizza">
        <h2>Hawaii</h2>
        <p>Pineapple, ham, tomato, cheese</p>

        <h2>Funghi</h2>
        <p>Mushrooms, tomato, cheese</p>

        <h2>Vegetariana</h2>
        <p>Tomato, cheese, mushrooms, bell peppers, onions, olives</p>
      </Card>
    </div>
  );
};

export default Food;
